export enum AppStage {
  production = 'production',
  sandbox = 'sandbox',
  development = 'development',
  cypress = 'test',
}
